/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentReport } from "./ShipmentReport";
import {
  ShipmentReportFromJSON,
  ShipmentReportFromJSONTyped,
  ShipmentReportToJSON,
  ShipmentReportToJSONTyped,
} from "./ShipmentReport";

/**
 *
 * @export
 * @interface ExperimentShipmentReportsResponse
 */
export interface ExperimentShipmentReportsResponse {
  /**
   *
   * @type {Array<ShipmentReport>}
   * @memberof ExperimentShipmentReportsResponse
   */
  shipmentReports: Array<ShipmentReport>;
  /**
   *
   * @type {number}
   * @memberof ExperimentShipmentReportsResponse
   */
  totalCount: number;
}

/**
 * Check if a given object implements the ExperimentShipmentReportsResponse interface.
 */
export function instanceOfExperimentShipmentReportsResponse(
  value: object,
): value is ExperimentShipmentReportsResponse {
  if (!("shipmentReports" in value) || value["shipmentReports"] === undefined)
    return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  return true;
}

export function ExperimentShipmentReportsResponseFromJSON(
  json: any,
): ExperimentShipmentReportsResponse {
  return ExperimentShipmentReportsResponseFromJSONTyped(json, false);
}

export function ExperimentShipmentReportsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentShipmentReportsResponse {
  if (json == null) {
    return json;
  }
  return {
    shipmentReports: (json["shipmentReports"] as Array<any>).map(
      ShipmentReportFromJSON,
    ),
    totalCount: json["totalCount"],
  };
}

export function ExperimentShipmentReportsResponseToJSON(
  json: any,
): ExperimentShipmentReportsResponse {
  return ExperimentShipmentReportsResponseToJSONTyped(json, false);
}

export function ExperimentShipmentReportsResponseToJSONTyped(
  value?: ExperimentShipmentReportsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentReports: (value["shipmentReports"] as Array<any>).map(
      ShipmentReportToJSON,
    ),
    totalCount: value["totalCount"],
  };
}
